<template>
  <div class="flex flex-col w-full">
    <div class="flex items-center justify-center">
      <div
        class="w-1/3 h-2 bg-neutral-300 relative"
        :class="{ 'bg-primary-200': currentStep >= 1 }"
      >
        <div class="absolute top-1/2 -left-1 rounded-full w-6 h-6 bg-primary-200 transform -translate-y-1/2"></div>
        <div
          class="whitespace-nowrap text-left text-xl sm:text-base
           xs:text-sm absolute -top-9 left-1/2 transform -translate-x-1/2"
          >
          {{ $t('landing.step') }} 1
        </div>
      </div>
      <div
        class="w-1/3 h-2 bg-neutral-300 relative"
        :class="{ 'bg-primary-200': currentStep >= 2 }"
      >
        <div
          class="rounded-full w-6 h-6 bg-neutral-300 absolute top-1/2 -left-1 transform -translate-y-1/2"
          :class="{ 'bg-primary-200': currentStep >= 2 }"
        ></div>
        <div
          class="whitespace-nowrap text-left text-xl sm:text-base
           xs:text-sm absolute -top-9 left-1/2 transform -translate-x-1/2"
        >
          {{ $t('landing.step') }} 2
        </div>
      </div>
      <div
        v-if="maxSteps === 3"
        class="w-1/3 h-2 bg-neutral-300 relative"
        :class="{ 'bg-primary-200': currentStep === 3 }"
      >
        <div
          class="rounded-full w-6 h-6 bg-neutral-300 absolute top-1/2 -left-1 transform -translate-y-1/2"
          :class="{ 'bg-primary-200': currentStep === 3 }"
        ></div>
        <div
          class="whitespace-nowrap text-left text-xl sm:text-base
           xs:text-sm absolute -top-9 left-1/2 transform -translate-x-1/2"
        >
          {{ $t('landing.step') }} 3
        </div>
      </div>
      <div
        class="rounded-full w-6 h-6 bg-neutral-300"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    currentStep: {
      type: [String, Number],
      default: 1,
    },
    maxSteps: {
      type: [String, Number],
      default: 3,
    },
  },
  computed: {
    currentWidth() {
      return `w-${this.currentStep}/${this.maxSteps}`;
    },
  },
};
</script>
<style></style>
